import React from 'react';
import ReactDOMServer from "react-dom/server";

const invitationComfortFollow = <div className="new-quote-container centered">
  <div className="splash-header">
    <h1 className="no-word-break">No worries, you’ve got this!</h1>
    <div className="quote">
      Many athletes prefer to train solo, and that works too. We’ll support you every step of the way to hit your goals.
    </div>
  </div>
</div>;

const invitationComfortFollowElement = {
  name: 'invitation-comfort-follow',
  type: 'html',
  html: ReactDOMServer.renderToStaticMarkup(invitationComfortFollow),
  visibleIf: `{invitationcomfort} == "No"`
}

export default invitationComfortFollowElement;
